module.exports = __webpack_public_path__ + "img/world-wide-web.c7da14ea.svg";